import API from "../request/api";
import request from "../request/request";

export default {
  getAbilityList(params) {
    return request.get(API.abilityList, params);
  },
  getMytask(params) {
    return request.get(API.mytask, params);
  },
  grab(params) {
    return request.put(API.grabOrder, params);
  },
  release(params) {
    return request.put(API.releaseOrder, params);
  },
  submitEvaluate(id, params) {
    return request.put(API.evaluate(id), params);
  },
  getEvaluationDetail(id) {
    return request.get(API.evaluateDetail(id));
  },
  getAbilityCategory() {
    return request.get(API.abilityCategory);
  }
};
